type HasNameAndCategory = {
  name: string;
  /** @example "株式会社" | "NPO法人" ... */
  category?: string;
  /** corpの一部のみに含まれる */
  category_postfix?: boolean;
};

type Option = {
  /** `true`を指定すると`"株式会社 〇〇"`, `"〇〇 株式会社"`, `"NPO法人 〇〇"`になる */
  hasSpace?: boolean;
};

export function getNameWithCategory(it: HasNameAndCategory, option: Option = {}) {
  // NOTE: spoのcategoryがその他の時はcategoryを表示しない
  if (!it.category || it.category === 'その他') {
    return it.name;
  }
  const maybeSpace = option.hasSpace ? ' ' : '';
  if (it.category_postfix) {
    return `${it.name}${maybeSpace}${it.category}`;
  } else {
    // NOTE: orgの場合は必ずこっちになる
    return `${it.category}${maybeSpace}${it.name}`;
  }
}
